import React from 'react';

interface DashboardChartProps {
  title: string;
  data: any[];
  dataKey: string;
  color?: string;
}

export default function DashboardChart({ 
  title, 
  data, 
  dataKey,
  color = '#1D4E4E' 
}: DashboardChartProps) {
  return (
    <div className="bg-white p-6 rounded-xl shadow-elevation-1">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
      <div className="h-64 flex items-center justify-center">
        <div className="text-gray-500">
          Gráfico temporariamente indisponível
        </div>
      </div>
    </div>
  );
}